// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bM8+o","link":"styles_link__zkpcu","text":"styles_text__ueNAg"};